// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type MergeHistoryModalQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type MergeHistoryModalQuery = { __typename?: 'Query', materialVariant: { __typename?: 'MaterialVariant', id: string, code: string, displayName: string, merges: Array<{ __typename?: 'MaterialVariantMerge', id: string, mergedFromId: string, mergedFromCode: string, mergedFromDisplayName: string, mergedIntoId: string, createdAt: Types.Scalars['DateTime']['input'], mergedBy?: { __typename?: 'User', id: string, name: string } | null | undefined }> } };

export type MergeHistoryModal_MaterialVariantFragment = { __typename?: 'MaterialVariant', id: string, code: string, displayName: string, merges: Array<{ __typename?: 'MaterialVariantMerge', id: string, mergedFromId: string, mergedFromCode: string, mergedFromDisplayName: string, mergedIntoId: string, createdAt: Types.Scalars['DateTime']['input'], mergedBy?: { __typename?: 'User', id: string, name: string } | null | undefined }> };

export const MergeHistoryModal_MaterialVariantFragmentDoc = gql`
    fragment MergeHistoryModal_MaterialVariant on MaterialVariant {
  id
  code
  displayName
  merges {
    id
    mergedFromId
    mergedFromCode
    mergedFromDisplayName
    mergedIntoId
    createdAt
    mergedBy {
      id
      name
    }
  }
}
    `;
export const MergeHistoryModalDocument = gql`
    query MergeHistoryModal($id: ID!) {
  materialVariant(id: $id) {
    ...MergeHistoryModal_MaterialVariant
  }
}
    ${MergeHistoryModal_MaterialVariantFragmentDoc}`;

/**
 * __useMergeHistoryModalQuery__
 *
 * To run a query within a React component, call `useMergeHistoryModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useMergeHistoryModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMergeHistoryModalQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMergeHistoryModalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MergeHistoryModalQuery, MergeHistoryModalQueryVariables> & ({ variables: MergeHistoryModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MergeHistoryModalQuery, MergeHistoryModalQueryVariables>(MergeHistoryModalDocument, options);
      }
export function useMergeHistoryModalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MergeHistoryModalQuery, MergeHistoryModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MergeHistoryModalQuery, MergeHistoryModalQueryVariables>(MergeHistoryModalDocument, options);
        }
// @ts-ignore
export function useMergeHistoryModalSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MergeHistoryModalQuery, MergeHistoryModalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MergeHistoryModalQuery, MergeHistoryModalQueryVariables>;
export function useMergeHistoryModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MergeHistoryModalQuery, MergeHistoryModalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MergeHistoryModalQuery | undefined, MergeHistoryModalQueryVariables>;
export function useMergeHistoryModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MergeHistoryModalQuery, MergeHistoryModalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MergeHistoryModalQuery, MergeHistoryModalQueryVariables>(MergeHistoryModalDocument, options);
        }
export type MergeHistoryModalQueryHookResult = ReturnType<typeof useMergeHistoryModalQuery>;
export type MergeHistoryModalLazyQueryHookResult = ReturnType<typeof useMergeHistoryModalLazyQuery>;
export type MergeHistoryModalSuspenseQueryHookResult = ReturnType<typeof useMergeHistoryModalSuspenseQuery>;
export type MergeHistoryModalQueryResult = ApolloReactCommon.QueryResult<MergeHistoryModalQuery, MergeHistoryModalQueryVariables>;